import { pxToRem } from "@input-output-hk/px-to-rem";
import React from "react";
import styled from "styled-components";
import { ItemComment } from "../../data/db/types";
import colors from "../../tokens/colors";
import Comment from "./Comment";

export const CommentsListElement = styled.ul`
  margin: 0;
  padding: 0;
  list-style: none;
`;

export const CommentsListItem = styled.li`
  & + & {
    margin-top: var(--spacing-xlarge);
  }
  &:last-child {
    border-bottom: ${pxToRem(1)} solid ${colors.secondary.ashGrey};
  }
  & & {
    margin-left: var(--spacing-large);
  }
  & &:last-child {
    border-bottom: none;
  }
`;

type Props = {
  comments: ItemComment[];
  onCommentChange?: () => void;
};
const CommentsList: React.FC<Props> = ({ comments, onCommentChange }) => {
  return (
    <CommentsListElement>
      {comments.map((c) => (
        <CommentsListItem key={c._id} data-comment-id={c._id}>
          <Comment comment={c} onCommentChange={onCommentChange} />
        </CommentsListItem>
      ))}
    </CommentsListElement>
  );
};

export default CommentsList;
